import React from 'react'
import { Grid } from 'semantic-ui-react'
import InputField from '../../../commonComponents/formComponents/inputField'
import { useSelector,useDispatch } from 'react-redux'
import { DropDown } from '../../../commonComponents/formComponents/dropDown'
import { useCurrentShipmentType } from '../../../hooks/useCurrentShipmentType'
import {addItemsTabWarnings,deleteItemsTabWarnings} from "../../actions/errorValidationActions";
import { validation } from '../../util/cdsFieldPatterns';
import PopUpIcon from '../../../commonComponents/formComponents/PopUpIcon';


const MerchForm8 = ({ isFormDisabled,merchandiseId,updateData,saveData, invoiceId,lineNumber}) => {
 
  const valuationMethodList=useSelector((state) => state.DropDownValues.valuationMethod)
  const valuationMethod=useSelector((state)=>state.InvoicesReducer.invoice.merchandise[merchandiseId]?.valuationMethod)
  const valuationIndicator=useSelector((state)=>state.InvoicesReducer.invoice.merchandise[merchandiseId]?.valuationIndicator)
  const declaredCustoms=useSelector((state)=>state.InvoicesReducer.invoice.merchandise[merchandiseId]?.declaredCustoms)
  const statisticalValue=useSelector((state)=>state.InvoicesReducer.invoice.merchandise[merchandiseId]?.statisticalValue)
  const supplementUnits=useSelector((state)=>state.InvoicesReducer.invoice.merchandise[merchandiseId]?.supplementUnits)
  const natureOfTransaction=useSelector((state)=>state.InvoicesReducer.invoice.merchandise[merchandiseId]?.natureOfTransaction)
  const itemType=useSelector((state)=>state.InvoicesReducer.invoice.merchandise[merchandiseId]?.itemType)

  const { declarationCat = '' } = useSelector((state) => state.Shipment) || []
  const getValidationError = React.useMemo(
    () => validation(declarationCat, 'itemsTab'),
    [declarationCat]
  )

  const dispatch=useDispatch()


  const addErrors = (level, value, fieldName) => {
    dispatch(addItemsTabWarnings(level, value, fieldName))
  }
  const deleteErrors = (level, value, fieldName) => {
    dispatch(deleteItemsTabWarnings(level, value, fieldName))
  }
    
  
    
  
  const currShipData = useCurrentShipmentType();
  const {isDisabled} = currShipData || {}
 
  return (
    <Grid.Row>
      <Grid.Column width='2' className='divFormFeild b-rw-0'>
      <DropDown
            id={`valuationMethod-${invoiceId}-${merchandiseId}`}
            label='valuationMethod'
            disabled={isDisabled || isFormDisabled}
            className='field-bg dropdown100 addInfoCode'
            boxNumber='4/16'
            labelClass='text-none'
            isLabel={true}
            mandatory={false}
            data={valuationMethodList}
            value={valuationMethod}
            errors={getValidationError("valuationMethod",valuationMethod,true)}
            clearable
            onChange={(value) =>{
              updateData({valuationMethod:value?.trim()})
              saveData({valuationMethod:value})
              let err = getValidationError('valuationMethod', value, 'itemsTab',true)
                          err.length
                            ? addErrors('itemsTab', `invoice -00${lineNumber + 1}`+ ' :: ' +err[0], `valuationMethod-${merchandiseId}`)
                            : deleteErrors('itemsTab', '', `valuationMethod-${merchandiseId}`)
            }}
            
          /> 
    
      </Grid.Column>
      <Grid.Column width='3' className='divFormFeild b-rw-0'>
        <InputField
          boxNumber='4/13'
          isLabel={false}
          id={`valuationIndicator-${invoiceId}-${merchandiseId}`}
          type='text'
          label='Valuation Indicator'
          mandatory={false}
          className='field-bg'
          clearInput={false}
          disabled={isFormDisabled}
          value={valuationIndicator}
          onChange={(value) =>updateData({valuationIndicator:value})}
          onBlur={()=>saveData({valuationIndicator:valuationIndicator || " " })}
        />
      </Grid.Column>
      <Grid.Column width='3' className='divFormFeild b-rw-0'>
        <InputField
         boxNumber='4/18'
          isLabel={false}
          id={`declaredCustoms-${invoiceId}-${merchandiseId}`}
          type='number'
          label="Declared Customs"
          disabled={isFormDisabled}
          value={declaredCustoms}
          className={`field-bg ${declarationCat!=="H7" ?  'opacity-50': ''}`}
          clearInput={declarationCat!=="H7"}
          onChange={(value) =>updateData({declaredCustoms:value})}
          onBlur={()=>saveData({declaredCustoms:declaredCustoms || " "})}
        />
      </Grid.Column>
      <Grid.Column width='2' className='divFormFeild b-rw-0'>
       
         <InputField
          isLabel={false}
          id={`statisticalValue-${invoiceId}-${merchandiseId}`}
          type='number'
          label='STATISTICAL VALUE'
          boxNumber="8/6"
          mandatory={false}
          value={statisticalValue}
          className='field-bg'
          clearInput={false}
          disabled={isFormDisabled}
          onChange={(value) =>updateData({statisticalValue:value})}
          onBlur={()=>saveData({statisticalValue:statisticalValue || " "})}
        />
      </Grid.Column>
      <Grid.Column width='3' className='divFormFeild b-rw-0'>
      <InputField
          isLabel={false}
          id={`supplementalUnits-${invoiceId}-${merchandiseId}`}
          type='number'
          label='Supplemental Units'
          labelIcon = {<PopUpIcon icon='info circle' popupText={itemType} />}
           boxNumber="6/2"
          mandatory={false}
          value={supplementUnits}
          className='field-bg'
          clearInput={false}
          disabled={isFormDisabled}  
          onChange={(value) =>updateData({supplementUnits:value})}
          onBlur={()=>saveData({supplementUnits:supplementUnits || " "})}
        />

    
      </Grid.Column>

      <Grid.Column width='3' className='divFormFeild'>
      <InputField
          isLabel={false}
          id={`transactionNature-${invoiceId}-${merchandiseId}`}
          type='number'
          label='Nature of Transaction'
          boxNumber="8/5"
          mandatory={false}
          className='field-bg'
          clearInput={false}
          disabled={isFormDisabled}
          value={natureOfTransaction}
          errors={getValidationError("natureOfTransaction",natureOfTransaction ||" ")}
          onChange={(value) =>updateData({natureOfTransaction:value})}
          onBlur={()=>{saveData({natureOfTransaction: natureOfTransaction || " "})
          let err = getValidationError('natureOfTransaction', natureOfTransaction || " ", 'itemsTab')
                          err.length
                            ? addErrors('itemsTab', `invoice -00${lineNumber + 1}`+ ' :: ' +err[0], `natureOfTransaction-${merchandiseId}`)
                            : deleteErrors('itemsTab', '', `natureOfTransaction-${merchandiseId}`)
        }}
        />

    
      </Grid.Column>
    </Grid.Row>
  )
}
export default React.memo(MerchForm8)
